// Brief factoid shown when an OpenEd state is correctly identified.
// One unified line across all 15 states — only the state name varies.
// Language follows OpenEd Vault/References/messaging-language-rules.md.

export default function OpenEdFactoid({ state }) {
  return (
    <div className="opened-factoid">
      <em>OpenEd families in {state.name}</em> access resources and support for personalized education.
    </div>
  );
}
